<template>
 <router-view/>
</template>
<script>
import { xray } from './config/pluginInit'
import { watch, onMounted, watchEffect } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'App',
  components: {
  },
  mounted () {
    xray.mainIndex()
  },
  setup () {
    const store = useStore()
    const applyTheme = (theme) => {
      document.body.setAttribute('data-theme', theme)
    }

    watch(() => store.state.theme.currentTheme, (newTheme) => {
      applyTheme(newTheme)
    }, { immediate: true })

    onMounted(() => {
      watchEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

        const listener = (e) => {
          const shouldSyncWithSystemTheme = localStorage.getItem('shouldSyncWithSystemTheme') === null ? true : localStorage.getItem('shouldSyncWithSystemTheme') === 'true'
          if (shouldSyncWithSystemTheme) {
            store.dispatch('theme/changeTheme', e.matches ? 'night' : 'light')
          }
        }
        mediaQuery.addEventListener('change', listener)
        return () => {
          mediaQuery.removeEventListener('change', listener)
        }
      })
    })
  }
}
</script>
<style lang="scss">
  @import "assets/scss/style.scss";
</style>
